<script setup lang="ts">
import { useI18n } from 'vue-i18n'
import { ref, watch } from 'vue'
import Checkbox from '@/components/input/Checkbox.vue'

const props = defineProps<{
  modelValue: boolean
  title: string
  message: string
  loading?: boolean
}>()
const emit = defineEmits<{
  'update:modelValue': [value: boolean]
  release: []
}>()

const { t } = useI18n()

const confirmed = ref(false)
watch(
  () => props.modelValue,
  (open) => {
    if (open) confirmed.value = false
  },
)
</script>

<template>
  <v-dialog
    :model-value="props.modelValue"
    scrollable
    @update:model-value="(v) => emit('update:modelValue', v)"
  >
    <v-card>
      <v-card-title>
        {{ props.title }}
      </v-card-title>
      <v-card-text>
        <slot />
        <v-alert type="warning" variant="outlined">
          {{ props.message }}
        </v-alert>

        <checkbox
          v-model="confirmed"
          :label="t('component.releaseConfirmationDialog.confirmation')"
        />
      </v-card-text>
      <v-card-actions>
        <v-btn @click="emit('update:modelValue', false)">
          {{ t('button.cancel') }}
        </v-btn>
        <v-spacer />
        <v-btn
          color="primary"
          variant="elevated"
          :disabled="!confirmed"
          :loading="props.loading"
          @click="emit('release')"
        >
          {{ props.title }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<style scoped lang="scss"></style>
